import { Injectable, inject } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';

declare global {
  interface Window {
    dataLayer: Record<string, unknown>[];
  }
}

@Injectable({
  providedIn: 'root',
})
export class GtmTrackingService {
  private readonly router = inject(Router);

  initialize(): void {
    window.dataLayer = window.dataLayer || [];

    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        this.trackPageView(event.urlAfterRedirects);
      });
  }

  pushEvent(event: string, data: Record<string, unknown> = {}): void {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event, ...data });
  }

  private trackPageView(url: string): void {
    this.pushEvent('pageview', { page: url });
  }
}
